import AxiosInstance from '../../../http-config'
import moment from 'moment'
import 'moment-timezone'
import { OperationRequest } from '../../requests/operation.request'
import {
  BalanceZoneStoreModel,
  CompanyStoreModel,
  getAppConfigurationValue
} from '../../../../redux'
import { EnumTipoOperacion } from '../../enums'
import { DispatchRequest, Operacion } from '../..'
import { DatePeriod } from '../../../../model'
import { AppConfigurationKey } from '../../../../model/enums/appConfigurationKey'
import { calculateGasDay } from '../../../../helpers/gasDayHelper'

export const apiNominacionesGET = async (
  operationTypes: EnumTipoOperacion[] | null,
  dateRange: DatePeriod,
  balanceZone: BalanceZoneStoreModel | undefined,
  company: CompanyStoreModel | undefined,
  logisticElement: number | undefined,
  justCount: boolean
): Promise<Array<Operacion>> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)

  const parseStartDate: string = moment(calculateGasDay(dateRange.start)).format('YYYY-MM-DD')
  const parseEndDate: string = moment(calculateGasDay(dateRange.end)).format('YYYY-MM-DD')

  let parameters = `?company=${company?.id}&balanceZone=${balanceZone?.code}&startDate=${parseStartDate}&endDate=${parseEndDate}&justForCount=${justCount}`
  let operation = `FetchOperations`

  if (logisticElement) {
    parameters += `&elemLog=${logisticElement}`
  }

  if (operationTypes?.length == 1) {
    parameters += `&opType=${operationTypes}`
    operation = `FetchOperationsByType`
  }

  return await AxiosInstance.get(`${apiSuffixUrl}/api/Operations/${operation}${parameters}`).then(
    response => {
      if (response.data.length > 0) {
        return response.data
      } else {
        return []
      }
    }
  )
}

export const apiFlangesGET = async (
  operationTypes: EnumTipoOperacion[] | null,
  logisticElements: number[],
  dateRange: DatePeriod,
  balanceZone: BalanceZoneStoreModel | undefined,
  company: CompanyStoreModel | undefined
): Promise<Array<Operacion>> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)

  const operationTypesFilter = operationTypes?.map(operation => `tipoOperacion eq '${operation}'`)
  let filter = operationTypesFilter?.join(' or ')

  const logisticElementsFilter = `elementoLogistico/id in (${logisticElements})`

  filter = `(${filter}) and ${logisticElementsFilter} and zonabalance eq '${balanceZone?.code}' and empresa/idempresa eq ${company?.id}`

  const parseStartDate: string = moment(calculateGasDay(dateRange.start)).format('YYYY-MM-DD')
  const parseEndDate: string = moment(calculateGasDay(dateRange.end)).format('YYYY-MM-DD')

  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/Operations/FetchOperations?company=${company?.id}&balanceZone=${balanceZone?.code}&startDate=${parseStartDate}&endDate=${parseEndDate}`
  ).then(response => {
    if (response.data.length > 0) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiNominacionesPOST = async (operacion: OperationRequest): Promise<boolean> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentFrontServices)

  return await AxiosInstance.post(`${apiSuffixUrl}/oData/Operaciones`, operacion).then(res => {
    return true
  })
}

export const apiNominacionesPATCH = async (
  operacion: OperationRequest,
  logisticElement?: number
): Promise<boolean> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentFrontServices)

  return await AxiosInstance.patch(
    `${apiSuffixUrl}/oData/Operaciones(${operacion.id},'${operacion.tipoOperacion}')`,
    operacion
  ).then(async () => {
    if (logisticElement) {
      return await AxiosInstance.post(
        `${apiSuffixUrl}/oData/Operaciones(${operacion.id},'${operacion.tipoOperacion}')/ElementoLogistico/$ref`,
        {
          '@odata.id': `${getAppConfigurationValue(
            AppConfigurationKey.Host
          )}odata/ElementosLogisticos(${logisticElement})`
        }
      ).then(() => {
        return true
      })
    }

    return true
  })
}

export const apiNominacionesDELETE = async (operacion: OperationRequest): Promise<boolean> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentFrontServices)

  return await AxiosInstance.delete(
    `${apiSuffixUrl}/oData/Operaciones(${operacion.id},'${operacion.tipoOperacion}')`
  ).then(() => {
    return true
  })
}

export const apiNominacionesGETById = async (ids: number[]): Promise<Array<Operacion>> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentFrontServices)

  let filter = ids.map((id: number) => `id eq ${id}`).join(' or ')

  return await AxiosInstance.get(
    `${apiSuffixUrl}/oData/Operaciones?&$filter=(${filter})&$expand=elementoLogistico,contraparte,empresa`
  ).then(response => {
    return response.data.value
  })
}
